import React from 'react'
import { Link } from "gatsby"
import { Map, TileLayer, Popup } from 'react-leaflet'
//import usePlaceData from '../static_queries/usePlaceData'
import useWineryData from '../static_queries/useWineryData'
import LeafletMarker from './LeafletMarker';
import Icon from './ActivityIcons';

export default function LeafletMap(props) {
  //const allPlaceData = usePlaceData()
  const allWineryData = useWineryData()
    return (
      <Map 
        bounds={props.bounds}
        minZoom={5}
        scrollWheelZoom={false}
        > 
        <TileLayer
          url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
          attribution={`&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>`}
          subdomains="abcd"
        />
        
        {allWineryData.map(winery => {
          const position = [winery.node.frontmatter.coordinates.lat, winery.node.frontmatter.coordinates.long]
          const wineryLink = `/uruguay/wineries/#${winery.node.frontmatter.slug}`
          return (
            <LeafletMarker key={winery.node.id} position={position} >
              <Popup className="winery">
                <Link
                  to={wineryLink}
                >
                  <Icon name="Drinks" width="10px" />
                  {winery.node.frontmatter.title}
                </Link>
              </Popup>
            </LeafletMarker>
          )
        })}
      </Map>
    );
 }
/*
 {allPlaceData.map(activity => {
  const position = [activity.node.frontmatter.location.coordinates.lat, activity.node.frontmatter.location.coordinates.long]
  return (
    <LeafletMarker key={activity.node.id} position={position} color="purple">
      <Popup className="places">
        <Link
          to={activity.node.fields.slug}
        >
          <Icon name="Town" width="16px" />
          {activity.node.frontmatter.title}
        </Link>
      </Popup>
    </LeafletMarker>
  )
})}

*/